import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Button from "react-bootstrap/Button";

import {
  emptyString,
  translationConstants,
  Directions,
  fieldLengthConstants,
  genderEnumReversed,
  globalConstants,
} from "../../../../../constants";
import { competitionActions } from "../../../../../redux/actions";
import { ToastifyService } from "../../../../../services";
import { SearchBoxIcon } from "../../../../../assets/images/icon/iconsProvider";
import { allSharedComponents } from "../../../../../shared";

const { ShowUserLevels } = allSharedComponents;

const AddParticipants = (props) => {
  const dispatch = useDispatch();
  const viewData = useSelector(
    (state) => state.CompetitionReducer.paticipantEmailData
  );
  const [formData, setFormData] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [selectedBoatClass, setSelectedBoatClass] = useState(null);

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const generalData = useSelector(
    (state) => state.CompetitionReducer.competitionGeneralDetail
  );

  const {
    setValue,
    register,
    trigger,
    clearErrors,
    formState: { errors },
  } = useForm();
  const { t } = useTranslation();

  const onSubmit = async () => {
    if (!formData?.classes?.length) {
      ToastifyService.showError(
        t(translationConstants.USER_INELIGIBLE_BECAUSE_NO_BOAT_CLASS_AVAILABLE)
      );
      return;
    }

    const isBoatClassValid = await trigger("boatClassId");
    if (!isBoatClassValid) {
      return;
    }
    if (viewData && Object.keys(viewData)?.length > 0) {
      const dataToSend = {
        systemUserId: viewData?.id,
        competitionId: props.competitionId,
        fee: 0,
        status: 0,
        genderBoatClassId: selectedBoatClass,
      };
      dispatch(
        competitionActions.addParticipant(dataToSend, props.setShow, () => {
          dispatch(
            competitionActions.getCompetitionParticipantsDetailById(
              props.competitionId,
              props.gridState
            )
          );
        })
      );
    } else {
      ToastifyService.showError(t(translationConstants.SEARCH_PRACTITIONER));
    }
  };

  const handleSearch = () => {
    if (searchInput) {
      dispatch(
        competitionActions.getParticipantByEmail({
          email: searchInput,
          competitionClasses: generalData?.classes,
        })
      );
    } else {
      ToastifyService.showError(t(translationConstants.invalidEmail));
    }
  };

  const handleSearchChange = (email) => {
    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check if the email matches the regular expression
    if (emailRegex.test(email)) {
      setSearchInput(email);
    } else {
      setSearchInput("");
    }
  };

  useEffect(() => {
    if (searchInput) {
      setFormData(viewData);
    } else {
      setFormData(null);
    }
    // eslint-disable-next-line
  }, [viewData]);

  useEffect(() => {
    dispatch(competitionActions.participantByEmailNull());
    // eslint-disable-next-line
  }, []);

  return (
    <section className="student-section">
      <div className="ViewHeader">
        <p className="viewUserPara">{t(translationConstants.addParticipant)}</p>
      </div>
      <p className="horizentalLine" />
      <div className="m-t-24">
        <Form noValidate className="ViewUserContent" onSubmit={handleSearch}>
          <div className="searcPaddingRight">
            <Form.Group className="form-group-register">
              <Form.Label className="Form-labels">
                {t(translationConstants.SEARCH_SAILOR)}:
              </Form.Label>
              <div className="searchInputDivBGWhite d-flex justify-content-center align-items-center">
                <Form.Control
                  className="inputWithoutOutline"
                  {...register("studentEmail", {})}
                  onChange={(e) => {
                    setValue("studentEmail", e.target.value, {
                      shouldValidate: true,
                    });
                    handleSearchChange(e.target.value);
                    trigger("studentEmail");
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch(); // Call handleSearch function
                    }
                  }}
                  id="studentEmail"
                  type="text"
                  maxLength={fieldLengthConstants.EMAIL_FIELD_LENGTH}
                />
                <div>
                  <SearchBoxIcon onClick={handleSearch} />
                </div>
              </div>
            </Form.Group>
          </div>

          <div className="inputRow">
            <Form.Group className="form-group-register">
              <Form.Label className="Form-labels">
                {t(translationConstants.firstName)}:
                {globalConstants.Mandatory_Character}
              </Form.Label>
              <Form.Control
                id="studentFirstName"
                type="text"
                maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                value={formData?.studentEnglishFirstName || emptyString}
                disabled={true}
              />
            </Form.Group>
            <Form.Group className="form-group-register">
              <Form.Label className="Form-labels">
                {t(translationConstants.lastName)}:
                {globalConstants.Mandatory_Character}
              </Form.Label>
              <Form.Control
                value={formData?.studentEnglishLastName || emptyString}
                id="studentLastName"
                type="text"
                maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                disabled={true}
              />
            </Form.Group>
          </div>

          <div className="inputRow">
            <Form.Group className="form-group-register">
              <Form.Label className="Form-labels">
                {t(translationConstants.firstNameArabic)}:{" "}
                {t(translationConstants.OPTIONAL)}
              </Form.Label>
              <Form.Control
                dir={Directions.rtl}
                value={formData?.studentArabicFirstName || emptyString}
                id="studentArabicFirstName"
                type="text"
                maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                disabled={true}
              />
            </Form.Group>
            <Form.Group className="form-group-register">
              <Form.Label className="Form-labels">
                {t(translationConstants.lastNameArabic)}:{" "}
                {t(translationConstants.OPTIONAL)}
              </Form.Label>
              <Form.Control
                dir={Directions.rtl}
                value={formData?.studentArabicLastName || emptyString}
                id="studentArabicLastName"
                type="text"
                maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                disabled={true}
              />
            </Form.Group>
          </div>

          <div className="inputRow">
            <Form.Group className="form-group-register">
              <Form.Label className="Form-labels">
                {`${t(
                  translationConstants.CHOOSE_BOAT_CLASS_FOR_COMPETITION
                )}:` + globalConstants.Mandatory_Character}
              </Form.Label>
              <Form.Select
                id="boatClassId"
                {...register("boatClassId", {
                  required: t(
                    translationConstants.COMPETITION_BOAT_CLASS_REQUIRED
                  ),
                })}
                onChange={(e) => {
                  setSelectedBoatClass(e.target.value);
                  e.target.value !== emptyString && clearErrors("boatClassId");
                }}
              >
                <option value="">
                  {t(translationConstants.SELECT_BOAT_CLASSS)}
                </option>
                {formData?.classes?.map((object) => {
                  const name =
                    direction === Directions.rtl && object.arabicName
                      ? object.arabicName
                      : object.name;
                  const genderText = t(
                    translationConstants[genderEnumReversed[object.gender]]
                  );
                  return (
                    <option key={object.id} value={object.id}>
                      {`${name} - ${genderText}`}
                    </option>
                  );
                })}
              </Form.Select>
              {errors?.boatClassId && (
                <p className="errorText">{errors?.boatClassId?.message}</p>
              )}
            </Form.Group>
          </div>

          {formData?.levels && (
            <div className="row mt-3">
              <label className="Form-labels form-label">
                {t(translationConstants.SAILOR_LEVEL)}:
              </label>
              <ShowUserLevels userLevels={formData?.levels} />
            </div>
          )}

          <Button
            className="SubmitDocs-button"
            type="button"
            disabled={!viewData}
            onClick={() => onSubmit()}
          >
            {t(translationConstants.submit)}
          </Button>
        </Form>
      </div>
    </section>
  );
};

export default AddParticipants;
